import { render } from "./DatabaseSyncLogsGroup.vue?vue&type=template&id=62057752"
import script from "./DatabaseSyncLogsGroup.vue?vue&type=script&lang=js"
export * from "./DatabaseSyncLogsGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__